import React, { useRef, useEffect } from "react";
import {
  BarcodeOutlined,
  CoffeeOutlined,
  DingdingOutlined,
  SoundOutlined,
} from "@ant-design/icons";
import { Flex, Radio, Button } from "antd";

const SoundSelector = ({ valueSelected, setValueSelected }) => {
  //manejo de url para sonido
  const fullUrl = window.location.href;
  const url = new URL(fullUrl);
  const baseDomainSound = `${url.protocol}//${url.hostname}`;

  // referencias para los elementos de audio  
  const ambienteAudioRef = useRef(
    new Audio(`${baseDomainSound}/sounds/ambiental.ogg`)
  );
  const pianoAudioRef = useRef(
    new Audio(`${baseDomainSound}/sounds/piano.ogg`)
  );
  const jazzAudioRef = useRef(new Audio(`${baseDomainSound}/sounds/jazz.ogg`));

  const onChange = (e) => {
    setValueSelected(e.target.value);
  };

  const stopAllSounds = () => {
    [ambienteAudioRef, pianoAudioRef, jazzAudioRef].forEach((ref) => {
      try {
        if (ref.current) {
          ref.current.pause();
          ref.current.currentTime = 0;
        }
      } catch (error) {
        console.error('Error stopping audio:', error);
      }
    });
  };

  const playSound = (audioRef, e) => {
    e.stopPropagation(); // Prevent the document click handler from firing

    // Detiene cualquier sonido que esté reproduciéndose
    stopAllSounds();

    // Reproduce el sonido seleccionado
    audioRef.current.play();
  };

  // Add document click event listener to stop sounds when clicking anywhere
  useEffect(() => {
    const handleDocumentClick = () => {
      stopAllSounds();
    };

    document.addEventListener("click", handleDocumentClick);

    //Clean up the event listener when component unmounts
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <Radio.Group
      onChange={onChange}
      value={valueSelected}
      options={[
        {
          value: 1,
          label: (
            <Flex gap="small" justify="center" align="center" vertical>
              <DingdingOutlined style={{ fontSize: 18 }} />
              Ambiente
              <Button
                type="text"
                icon={<SoundOutlined />}
                size="small"
                onClick={(e) => playSound(ambienteAudioRef, e)}
              />
            </Flex>
          ),
        },
        {
          value: 2,
          label: (
            <Flex gap="small" justify="center" align="center" vertical>
              <BarcodeOutlined style={{ fontSize: 18 }} />
              Piano
              <Button
                type="text"
                icon={<SoundOutlined />}
                size="small"
                onClick={(e) => playSound(pianoAudioRef, e)}
              />
            </Flex>
          ),
        },
        {
          value: 3,
          label: (
            <Flex gap="small" justify="center" align="center" vertical>
              <CoffeeOutlined style={{ fontSize: 18 }} />
              Jazz
              <Button
                type="text"
                icon={<SoundOutlined />}
                size="small"
                onClick={(e) => playSound(jazzAudioRef, e)}
              />
            </Flex>
          ),
        },
      ]}
    />
  );
};

export default SoundSelector;
